<template>
  <div class="sidebar mobilehide">
    <el-row class="tac">
      <el-col :span="24">
        <div class="sidbar-logo"></div>
        <el-menu
          class="text-center"
          default-active="1"
          @open="menuHandleOpen"
          @close="menuHandleClose"
          :collapse="menuIsCollapse"
        >
          <el-tooltip
            :content="'Parkhäuser'"
            placement="right"
            effect="light"
            :open-delay="500"
            :hide-after="3000"
          >
            <el-menu-item
              class="vue-menu-item"
              index="1"
              @click="navigation('main')"
            >
              <i class="fas fa-building"></i>
            </el-menu-item>
          </el-tooltip>
          <el-tooltip
            :content="'Reporting'"
            placement="right"
            effect="light"
            :open-delay="500"
            :hide-after="3000"
          >
            <el-menu-item
              class="vue-menu-item"
              index="2"
              @click="navigation('reporting')"
            >
              <i class="fas fa-chart-bar"></i>
            </el-menu-item>
          </el-tooltip>
          <el-tooltip
            :content="'Benutzerhandbuch'"
            placement="right"
            effect="light"
            :open-delay="500"
            :hide-after="3000"
          >
            <el-menu-item
              class="vue-menu-item"
              index="3"
              @click="navigation('userManual')"
            >
              <i class="fas fa-book"></i>
            </el-menu-item>
          </el-tooltip>
          <el-tooltip
            :content="'Einstellung Baumstruktur'"
            placement="right"
            effect="light"
            :open-delay="500"
            :hide-after="3000"
          >
            <el-menu-item
              class="vue-menu-item"
              index="4"
              @click="navigation('contentSettingsMain')"
            >
              <i class="fas fa-cog"></i>
            </el-menu-item>
          </el-tooltip>
          <el-tooltip
            :content="'Benutzereinstellungen'"
            placement="right"
            effect="light"
            :open-delay="500"
            :hide-after="3000"
          >
            <el-menu-item
              class="vue-menu-item"
              index="6"
              @click="navigation('settings')"
            >
              <i class="fas fa-fw fa-wrench"></i>
            </el-menu-item>
          </el-tooltip>
          <el-tooltip
            :content="'Ausloggen'"
            placement="right"
            effect="light"
            :open-delay="500"
            :hide-after="3000"
          >
            <el-menu-item
              class="vue-menu-item"
              index="7"
              @click="$emit('logout')"
            >
              <i class="fas fa-fw fa-sign-out"></i>
            </el-menu-item>
          </el-tooltip>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "SideBar",
  data() {
    return {
      menuIsCollapse: false,
      menuHandleOpen: true,
      menuHandleClose: true
    };
  },
  methods: {
    navigation(target) {
      this.$emit("navigation", target);
    }
  }
};
</script>
